import { RadioCard } from '@chakra-ui/react';
import { Fragment } from 'react';

type RadioCardItemProps = RadioCard.ItemProps & {
  icon?: React.ReactElement;
  label?: React.ReactNode;
  description?: React.ReactNode;
  addon?: React.ReactNode;
  indicator?: React.ReactNode | null;
  indicatorPlacement?: 'start' | 'end' | 'inside';
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  ref?: React.RefObject<HTMLInputElement>;
};

export const RadioCardItem = ({
  ref,
  inputProps,
  label,
  description,
  addon,
  icon,
  indicator = <RadioCard.ItemIndicator />,
  indicatorPlacement = 'end',
  ...rest
}: RadioCardItemProps) => {
  const hasContent = label || description || icon;
  const ContentWrapper = indicator ? RadioCard.ItemContent : Fragment;

  return (
    <RadioCard.Item
      {...rest}
      flex={0}
      _checked={{
        bgColor: 'purple.200',
        borderColor: 'purple.200',
        boxShadow: 'sm',
      }}
    >
      <RadioCard.ItemHiddenInput ref={ref} {...inputProps} />
      <RadioCard.ItemControl px={5} py={2}>
        {indicatorPlacement === 'start' && indicator}
        {hasContent && (
          <ContentWrapper>
            {icon}
            {label && (
              <RadioCard.ItemText whiteSpace="nowrap" textStyle="title">
                {label}
              </RadioCard.ItemText>
            )}
            {description && <RadioCard.ItemDescription>{description}</RadioCard.ItemDescription>}
            {indicatorPlacement === 'inside' && indicator}
          </ContentWrapper>
        )}
        {indicatorPlacement === 'end' && indicator}
      </RadioCard.ItemControl>
      {addon && <RadioCard.ItemAddon>{addon}</RadioCard.ItemAddon>}
    </RadioCard.Item>
  );
};

export const RadioCardRoot = RadioCard.Root;
export const RadioCardLabel = RadioCard.Label;
export const RadioCardItemIndicator = RadioCard.ItemIndicator;
